// Presentation helpers for the group member-management page (隱藏成員).

// "在 N 本帳本有紀錄 · X 本未結清" summary line under a member's name.
export const memberMetaText = (user) => {
  const books = user.accountingBooksCount || 0
  if (books === 0) {
    return '沒有任何帳款紀錄'
  }

  const unsettled = user.unsettledBooksCount || 0
  if (unsettled > 0) {
    return `在 ${books} 本帳本有紀錄 · ${unsettled} 本未結清`
  }

  return `在 ${books} 本帳本有紀錄 · 全部結清`
}

// Reason shown when the hide action is disabled.
export const hideBlockedReason = (user) => {
  const unsettled = user.unsettledBooksCount || 0
  if (unsettled > 0) {
    return `他還有 ${unsettled} 本帳本未結清，結清後才能隱藏。`
  }
  return '目前無法隱藏這位成員。'
}
